<template>
  <div class="banner-create-container">
    <h2>添加轮播图</h2>
    <el-card shadow="hover">
      <el-form
        :model="bannerForm"
        :rules="rules"
        ref="bannerFormRef"
        label-position="top"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="bannerForm.title" placeholder="请输入标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图片URL" prop="image_url">
              <el-input v-model="bannerForm.image_url" placeholder="请输入图片URL" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="链接地址" prop="link_url">
              <el-input v-model="bannerForm.link_url" placeholder="请输入链接地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="bannerForm.status">
                <el-radio label="active">启用</el-radio>
                <el-radio label="inactive">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序" prop="sort_order">
              <el-input v-model="bannerForm.sort_order" type="number" placeholder="请输入排序号" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input v-model="bannerForm.description" type="textarea" placeholder="请输入描述" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <div class="form-actions">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'BannerCreate',
  setup() {
    const router = useRouter();
    const bannerFormRef = ref(null);
    
    const bannerForm = ref({
      title: '',
      image_url: '',
      link_url: '',
      status: 'active',
      sort_order: 0,
      description: ''
    });
    
    const rules = {
      title: [
        { required: true, message: '请输入标题', trigger: 'blur' }
      ],
      image_url: [
        { required: true, message: '请输入图片URL', trigger: 'blur' },
        { type: 'url', message: '请输入正确的URL格式', trigger: 'blur' }
      ],
      link_url: [
        { type: 'url', message: '请输入正确的URL格式', trigger: 'blur' }
      ]
    };
    
    // 提交表单
    const handleSubmit = async () => {
      if (!bannerFormRef.value) return;
      
      await bannerFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await request({
              url: '/manage/banners',
              method: 'post',
              data: bannerForm.value
            });
            ElMessage.success('轮播图创建成功');
            // 添加延迟确保组件状态稳定后再导航，避免卸载时的错误
            setTimeout(() => {
              router.push('/contents/banners');
            }, 0);
          } catch (error) {
            ElMessage.error('轮播图创建失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 取消操作
    const handleCancel = () => {
      // 添加延迟确保组件状态稳定后再导航，避免卸载时的错误
      setTimeout(() => {
        router.push('/contents/banners');
      }, 0);
    };
    
    return {
      bannerForm,
      bannerFormRef,
      rules,
      handleSubmit,
      handleCancel
    };
  }
};
</script>

<style scoped>
.banner-create-container {
  padding: 20px;
}

.banner-create-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}
</style>